// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ct-date-value[data-v-ebf2a282]{display:flex;color:#0f1214;font-size:0.24rem;align-items:center;justify-content:flex-end}.arrow-icon-small[data-v-ebf2a282]{height:0.38rem;width:0.52rem;text-align:center}.arrow-icon-small .arrow-icon[data-v-ebf2a282]{width:0.4rem;height:0.4rem}.arrow-icon-small .rotate[data-v-ebf2a282]{transform:rotate(180deg);transition:all .3s linear}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
